import { render, staticRenderFns } from "./CompanyInfoDetails.vue?vue&type=template&id=1fc975e6&scoped=true"
import script from "./CompanyInfoDetails.vue?vue&type=script&lang=js"
export * from "./CompanyInfoDetails.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfoDetails.vue?vue&type=style&index=0&id=1fc975e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc975e6",
  null
  
)

export default component.exports